module.exports = __webpack_public_path__ + "img/60.ea16a700.jpg";